import { render, staticRenderFns } from "./CriticismEndorsement.vue?vue&type=template&id=3b6faa74"
import script from "./CriticismEndorsement.vue?vue&type=script&lang=js"
export * from "./CriticismEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports